export class AlphaListLegend {
  public search_specialties = [];
  public procedures = [];
  public incentivized_procedures = [];
  public incentivized_specialties = [];
  public provider_types = [];
}
